import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PublicLayout from "../../../../layouts/user/PublicLayout";
import BeritaPopuler from "../../../../components/user/posts/BeritaPopuler";
import { Gallery } from "react-grid-gallery";
import { IoMdCamera } from "react-icons/io";
import DetailsFoto from "../../../../components/user/galeri/foto/DetailsFoto";

function Foto() {
	const [images, setImages] = useState([]);
	const [selectedPhoto, setSelectedPhoto] = useState(null);
	const [loading, setLoading] = useState(true);

	const truncateText = (text, maxLength) => {
		if (text.length > maxLength) {
			return text.slice(0, maxLength) + "...";
		}
		return text;
	};

	useEffect(() => {
		const fetchImages = async () => {
			try {
				const response = await axios.get("/api_w/galleries?type=image", {
					headers: {
						db_name: process.env.REACT_APP_DB_NAME,
					},
				});
				const formattedImages = response.data.data.map((image) => ({
					src: image.url.split(",")[0],
					thumbnail: image.url.split(",")[0],
					width: 320,
					height: 212,
					caption: image.title,
					thumbnailCaption: (
						<>
							<div
								onClick={() => setSelectedPhoto(image)}
								className="flex justify-center items-center bg-green-600 opacity-75 text-white p-1 font-bold text-sm cursor-pointer rounded-b-md md:block hidden text-center"
							>
								{truncateText(image.title, 32)}
							</div>
							<div
								onClick={() => setSelectedPhoto(image)}
								className="flex justify-center items-center bg-green-600 opacity-75 text-white p-1 font-bold text-sm cursor-pointer rounded-b-md md:hidden text-center"
							>
								{truncateText(image.title, 15)}
							</div>
						</>
					),
					customOverlay: (
						<div className="custom-overlay absolute inset-0 flex justify-center items-center">
							<button
								onClick={() => setSelectedPhoto(image)}
								className="bg-white opacity-75 p-4 rounded-full shadow-lg hover:bg-green-100 transition-colors duration-300"
							>
								<IoMdCamera className="h-7 w-7 text-green-600" />
							</button>
						</div>
					),
				}));

				setImages(formattedImages);
				setLoading(false);
			} catch (error) {
				toast.error(error.response?.data?.message || error.message);
				setLoading(false);
			}
		};

		fetchImages();
	}, []);

	const handleCloseDetails = () => {
		setSelectedPhoto(null);
	};

	return (
		<PublicLayout title="Galeri Foto" subtitle="Dokumentasi kegiatan madrasah">
			<div className="flex flex-col lg:flex-row gap-8">
				<div className="w-full lg:w-[68%]">
					<h3 className="text-xl mb-4">
						<span className="border-b-2 border-green-600 font-bold hover:cursor-pointer hover:text-green-700">
							Foto
						</span>
					</h3>
					{loading ? (
						<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-4">
							{Array.from({ length: 6 }).map((_, i) => (
								<div
									key={i}
									className="animate-pulse rounded bg-gray-300 h-40 w-full rounded-lg"
								/>
							))}
						</div>
					) : (
						<Gallery
							images={images}
							enableImageSelection={false}
							backdropClosesModal={true}
							margin={8}
						/>
					)}
				</div>
				<div className="w-full lg:w-[30%]">
					<BeritaPopuler />
				</div>
			</div>

			{selectedPhoto && (
				<div className="fixed inset-0 bg-gray-800 bg-opacity-70 flex items-center justify-center z-50">
					<DetailsFoto photo={selectedPhoto} onClose={handleCloseDetails} />
				</div>
			)}
		</PublicLayout>
	);
}

export default Foto;
